import { render, staticRenderFns } from "./EnglishAutoCompleteUserSearch.vue?vue&type=template&id=ae2c1d82&scoped=true"
import script from "./EnglishAutoCompleteUserSearch.vue?vue&type=script&lang=ts"
export * from "./EnglishAutoCompleteUserSearch.vue?vue&type=script&lang=ts"
import style0 from "./EnglishAutoCompleteUserSearch.vue?vue&type=style&index=0&id=ae2c1d82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae2c1d82",
  null
  
)

export default component.exports